export enum EIndexPoderJudicial {
  CIVIL = "civil",
  LABORAL = "laboral",
  COBRANZA = "cobranza"
}